import { pxToRem } from 'src/common/utils/fonts';

export const getOptionNameOverflowDimensions = (withId?: boolean) => {
  return {
    maxNumberOfCharacters: withId ? 30 : 40,
    nameWidth: withId ? pxToRem(185) : pxToRem(250),
  };
};
